import { render, staticRenderFns } from "./Object.vue?vue&type=template&id=3439113e&scoped=true&"
import script from "./Object.vue?vue&type=script&lang=js&"
export * from "./Object.vue?vue&type=script&lang=js&"
import style0 from "./Object.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Object.vue?vue&type=style&index=1&id=3439113e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439113e",
  null
  
)

export default component.exports